import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { environment } from './core/environments/environment';
import { httpRequestInterceptor } from './core/interceptors/http-request.interceptor';
import { ApiModule, Configuration } from '@sdk/gestione-sottoscrizione';

const sdkBasePath = (() => {
  if (typeof window === 'undefined') return 'https://gestsot.ancebrick.cloud';
  const hostname = window.location.hostname;

  if (hostname === 'localhost') return 'http://localhost:3001';
  if (hostname === 'gestsot.ancebrick.cloud') return 'https://gestsot.ancebrick.cloud';
  if (hostname === 'eventi.ance.it') return 'https://eventi.ance.it';

  return ''; // fallback
})();


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
        provideHttpClient(
      withFetch(),
      withInterceptors([httpRequestInterceptor])
    ),
      { provide: LOCALE_ID, useValue: 'it-IT' },
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    importProvidersFrom(ApiModule.forRoot(() => new Configuration({ basePath: sdkBasePath })))
  ],
};


